import Cookies from 'js-cookie';

export const getValue = (prefix: string, key: string): string | undefined => {
  key = prefixedKey(prefix, key);
  return Cookies.get(key);
};

/** `expires` takes days or a date; js-cookie understands both. */
export const setValue = (
  prefix: string,
  key: string,
  value: string,
  expires?: number | Date,
  attributes?: Pick<Cookies.CookieAttributes, 'sameSite' | 'secure'>,
) => {
  key = prefixedKey(prefix, key);
  Cookies.set(key, value, { expires, ...attributes });
};

export const removeValue = (prefix: string, key: string) => {
  key = prefixedKey(prefix, key);
  Cookies.remove(key);
};

const prefixedKey = (prefix: string, key: string): string => `${prefix}_${key}`;
